import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { PRODUCT_SELECTOR_FRAGMENT } from 'graphql/fragments/product-selector';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_SELECTOR_ASSIGNMENT_MUTATION = gql`
  mutation updateSelectorAssignment(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!,
    $variableAssignment: VariableAssignmentInput!,
    $withConfiguration: Boolean!,
    $datamodelVersionId: ID!,
    $filtersId: ID!,
    $frameImageId: ID!,
    $vtzFileId: ID!,
    $elementFilterId: ID!,
    $typeFilterId: ID!
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          configuration {
            assign(variableAssignment: $variableAssignment) {
              line {
                ...ProductSelectorFragment
              }
            }
          }
        }
      }
    }
  }
  ${PRODUCT_SELECTOR_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateSelectorAssignmentMutation extends Mutation<RootMutation> {
  document = UPDATE_SELECTOR_ASSIGNMENT_MUTATION;
}
